import { CardType } from '../../Prototype/Level/Card/CardType';
import { ICardModifierData } from '../../Prototype/Level/Card/ICardModifierData';
import { CardTask } from './CardTasks';
import { CardColor } from '../../Utility/CardsHelper';
import Point from 'Utility/Point';

export function cardCastsTo<T extends CardType>(card: ICardStateData, type: T): card is ICardStateData & { type: T } {
    return card.type === type;
}

export type ICardStateData =
    | BoomCardData
    | ZapCardData
    | LockCardData
    | KeyCardData
    | PlusThreeCardData
    | ValueCardData
    | StoneCardData
    | ScissorsCardData
    | TornadoCardData
    | JokerCardData
    | GoldCardData
    | CanisterPreBoosterCardData
    | JokerPreBoosterCardData
    | PlinkoCardData;

export interface IBaseCardData {
    id: string;
    depth: number;
    faceUp: boolean;
    sequence: number;
    modifiers: ICardModifierData[];
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
    scale: Point;
    offset: Point;
    value: number;
    attempts: number; // Number of attempts to play the card.
}

export type BoomCardData = IBaseCardData & {
    type: CardType.boom;
};

export type ZapCardData = IBaseCardData & {
    type: CardType.zap;
};

export type LockCardData = IBaseCardData & {
    type: CardType.lock;
};

export type KeyCardData = IBaseCardData & {
    type: CardType.key;
};

export type PlusThreeCardData = IBaseCardData & {
    type: CardType.plus_three;
};

export type ValueCardData = IBaseCardData & {
    type: CardType.value;
    value: number;
    random: boolean;
};

export type StoneCardData = IBaseCardData & {
    type: CardType.rock;
};

export type ScissorsCardData = IBaseCardData & {
    type: CardType.scissors;
};

export type TornadoCardData = IBaseCardData & {
    type: CardType.tornado;
};

export type JokerCardData = IBaseCardData & {
    type: CardType.joker;
};

export type GoldCardData = IBaseCardData & {
    type: CardType.gold;
    suit: number;
    random: boolean;
};

export type CanisterPreBoosterCardData = IBaseCardData & {
    type: CardType.canister_pre_booster;
};

export type JokerPreBoosterCardData = IBaseCardData & {
    type: CardType.joker_pre_booster;
    madeByBooster: boolean;
    hitArea?: ICardStateData;
};

export type PlinkoCardData = IBaseCardData & {
    type: CardType.plinko;
};

export enum StreakReward {
    OneCard,
    TwoCards,
    Joker,
}

/**
 * Card action data used to trigger state animations.
 */
export interface ICardStateTaskData {
    task: CardTask;
    cards: string[];

    [key: string]: any;
}

export interface ICardsState {
    cards: {
        [id: string]: ICardStateData;
    };
    inPlay: string[];
    inStack: string[];
    folded: string[];
    discarded: string[];
    turns: number;
    tasks: ICardStateTaskData[];
    matchSequence: CardColor[];
    turnScore: number;
    undoHistory: {
        cards: Record<string, ICardStateData>;
        matchSequence: CardColor[];
        streakScore: number;
        [key: string]: any;
    }[];

    /**
     * Temp fix to control streak functionality at the card-state level because it would be too much work to
     * elevate cardState to levelState in all of CardStateHelper.
     * TODO: Elevate cardState data to levelState.
     */
    streakEnabled: boolean;
    streakReward: StreakReward;
    streakScore: number;
}
